import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';
import PaginateTotal from '../common/PaginateTotal';
import ReactPaginate from 'react-paginate';
import { nl2br } from '../common/Utils'
import moment from 'moment';

function ConsultationListTable(props) {
    const { t } = props;
    const { items, pageNo, pageSize, total, handlePageChange } = props;

    if (items === null) {
        return (
            <p>Loading Consultation Paper record ...</p>
        );
    } else {
        return (
            <div className="table-container main-style consultation-paper-table">
                <table>
                    <tbody>
                        <tr>
                            <th>
                                <a>{t('consultation.table.header.title')}</a>
                            </th>
                            <th>
                                <a>{t('consultation.table.header.response')}</a>
                            </th>
                            <th>
                                <a>{t('consultation.table.header.conclusion')}</a>
                            </th>
                        </tr>
                    </tbody>
                    <tbody>
                    {items.map((item) => {
                        const docUrl = `doc?refNo=${item.cpRefNo}`;
                        return (
                        <tr key={item.cpRefNo}>
                            <td>
                                {t('consultation.date.formatter',{date: moment(item.cpIssueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                                <br/>
                                <Link to={docUrl}>{item.cpTitle}</Link>
                            </td>
                            <ResponseColumn cp={item} />
                            <ConclusionColumn cp={item} />
                        </tr>
                        );
                    })}
                    </tbody>
                </table>
                <div className="pagination-toolbar">
                    <PaginateTotal pageNo={pageNo} pageSize={pageSize} total={total} />
                    <div className="pagination-toolbar pagebar">
                        <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel={'. . .'}                                        
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={7}
                            initialPage={pageNo}
                            disableInitialCallback={true}
                            pageCount={Math.ceil(total/pageSize)}
                            onPageChange={handlePageChange}
                            containerClassName={'pagination'}
                            previousClassName={'previous'}
                            breakClassName={'break'}
                            pageClassName={'page'}
                            activeClassName={'active'}
                            nextClassName={'next'}/>
                    </div>                        
                </div>
            </div>
        );
    }
}

function ResponseColumn(props) {
    const { t, i18n } = useTranslation();
    const { cp } = props;

    if (cp.beforeArchiveDate) {
        if (cp.firstCommentIssueDate !== null) {
            return (
                <td>
                    {t('consultation.date.formatter',{date: moment(cp.firstCommentIssueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                    <br/>
                    <Link to={`response?refNo=${cp.cpRefNo}`}>
                        {t("consultation.table.label.viewComment")}
                    </Link>
                </td>
            );
        } else {
            return (
                <td>{t("consultation.table.label.notApplicable")}</td>
            );
        }
    } else {
        if (cp.firstCommentIssueDate !== null) {
            return (
                <td>
                    {t('consultation.date.formatter',{date: moment(cp.firstCommentIssueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                    <br/>
                    <Link to={`response?refNo=${cp.cpRefNo}`}>
                        {t("consultation.table.label.viewComment")}
                    </Link>
                </td>
            );
        } else if (cp.ccRefNo !== null) {
            return (
                <td>
                    {t('consultation.date.formatter',{date: moment(cp.ccIssueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                    <br/>
                    <Link to={`response?refNo=${cp.cpRefNo}`}>
                        {t("consultation.table.label.viewComment")}
                    </Link>
                </td>
            );
        } else {
            return (
                <td>{t("consultation.table.label.pending")}</td>
            );
        }
    }
}

function ConclusionColumn(props) {
    const { t, i18n } = useTranslation();
    const { cp } = props;

    let appendixDocList = [];
    if (Array.isArray(cp.ccAppendixDocList) && cp.ccAppendixDocList.length>=0) {
        appendixDocList = (
            <ul className="apendcol">
            {cp.ccAppendixDocList.map((appendix) => {
                const dateOnWeb = [];
                if (appendix.dateOnWeb !== null) {
                    dateOnWeb.push(t('common:date.formatter',{date: moment(appendix.dateOnWeb, "YYYY-MM-DDTHH:mm:ss").toDate()}));
                    dateOnWeb.push(<br/>);
                }
                return (
                    <li key={appendix.refNo}>
                        {dateOnWeb}
                        <Link to={`openConclusionAppendix?refNo=${cp.cpRefNo}&appendix=${appendix.refNo}`} target="_blank">
                            {appendix.caption}
                        </Link>
                    </li>
                    );
                }
            )}
            </ul>
        );
    }

    if (cp.ccRefNo !== null) {
        return (
            <td>
                {t('consultation.date.formatter',{date: moment(cp.ccIssueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                <br/>
                <Link to={`conclusion?refNo=${cp.cpRefNo}`} target="_blank">
                    {cp.ccTitle}
                </Link>
                {appendixDocList}
            </td>
        );
    } else if (cp.beforeArchiveDate) {
        return (
            <td>{t("consultation.table.label.notApplicable")}</td>
        );
    } else {
        return (
            <td>{t("consultation.table.label.pending")}</td>
        );
    }
}


export default withRouter(withTranslation()(ConsultationListTable));